import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from 'app/auth/auth.service';
import { InputGeneralComponent } from 'app/components/input-general/input-general.component';
import { CHANGE_LANGUAGE } from 'app/shared/utils';
import { environment } from 'environments/environment';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    standalone: true,
    imports: [
        InputGeneralComponent,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        TranslateModule,
        RouterModule,
    ],
    styles: [
        `
            :host {
                width: 100%;
            }
        `,
    ],
    styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent {
    forgotPasswordForm: FormGroup;
    submitted = false;
    captchaResolved: boolean = false;
    isRequired;
    siteKey = environment.siteKey;
    selectedLanguage: any;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private authService: AuthService,
        private translate: TranslateService,
        private toastr: ToastrService,
    ) {}

    ngOnInit(): void {
        this.selectedLanguage = localStorage.getItem('language');
        this.forgotPasswordForm = this.fb.group({
            username: ['', Validators.required],
            recaptcha: ['', [Validators.required]],
        });
        this._translate();
    }

    private _translate() {
        this.translate.get('ERROR.IS_REQUIRED').subscribe((data: any) => {
            this.isRequired = data;
        });
    }

    get f() {
        return this.forgotPasswordForm.controls;
    }

    getErrors(input: any, inputName?: any): Array<any> {
        let errors = [];

        if (this.f[input].touched || this.submitted) {
            if (this.f[input].errors?.required) {
                errors.push(inputName + ' ' + this.isRequired);
            }
        }
        return errors;
    }

    onCheckCaptcha(captchaResponse: string) {
        this.captchaResolved =
            captchaResponse && captchaResponse.length > 0 ? true : false;
    }

    goToSignUp() {
        this.router.navigate(['/sign-up']);
    }

    onForgotPassword(): void {
        this.submitted = true;

        const userDetails = {
            username: this.forgotPasswordForm.value.username,
        };

        if (this.forgotPasswordForm.valid) {
            this.authService.forgotPassword(userDetails).subscribe({
                next: () => {
                    localStorage.setItem(
                        'username',
                        this.forgotPasswordForm.value.username
                    );
                    this.router.navigate(['/reset-password']);
                },
                error: (err) => {
                    this.toastr.error(err.error.message);
                },
            });
        }
    }

    switchLanguage(language: string) {
        CHANGE_LANGUAGE(language, this.router.url, this.translate);
        this._translate();
    }
}
